export default "__VITE_ASSET__CxAcca8K__"